import loadable from '@loadable/component';

import './ForgotPassword.css';

export default loadable(() => {
  return import('./ForgotPassword.jsx');
});
